import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { CommonConfig } from "../../CommonConfig.js";
import api from "../../utils/api";
import cogoToast from "cogo-toast";
import APIConstant from "../../utils/constant";
// import { FilterMatchMode } from 'primereact/api';
import { InputSwitch } from "primereact/inputswitch";
import { Dropdown } from "primereact/dropdown";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Checkbox } from "primereact/checkbox";

let configList = [
  {
    label: "Manufacturing Barcode",
    value: "Manufacturing Barcode",
  },
  {
    label: "Variant Template",
    value: "Variant Template",
  },
  {
    label: "Billing Template",
    value: "Billing Template",
  },
  {
    label: "Billing Configuration",
    value: "Billing Configuration",
  },
  {
    label: "Manufacturing Template",
    value: "Manufacturing Template",
  },
];

// let configValueObject = {
//   "Manufacturing Barcode": {
//     "Barcode Name": true,
//     Barcode: true,
//     "Manufacturing Date": true,
//     "Expiry Date": true,
//     Mrp: true,
//     Rate: true,
//     "Life Span": true,
//   },
// };
let configValueList = {
  "Manufacturing Barcode": [
    {
      label: "Header",
      value: "Header",
      checked: true,
    },
    {
      label: "Image",
      value: "Image",
      checked: true,
    },
    {
      label: "Footer",
      value: "Footer",
      checked: true,
    },
    {
      label: "Item Name",
      value: "ItemName",
      checked: true,
    },
    {
      label: "Barcode Name",
      value: "BarcodeName",
      checked: true,
    },
    {
      label: "Barcode",
      value: "Barcode",
      checked: true,
    },
    {
      label: "Manufacturing Date",
      value: "ManufacturingDate",
      checked: true,
    },
    {
      label: "Expiry Date",
      value: "ExpiryDate",
      checked: true,
    },
    {
      label: "Mrp",
      value: "Mrp",
      checked: true,
    },
    {
      label: "Rate",
      value: "Rate",
      checked: true,
    },
    {
      label: "USP",
      value: "USP",
      checked: true,
    },
    {
      label: "Weight",
      value: "Weight",
      checked: true,
    },
    {
      label: "Batch No",
      value: "BatchNo",
      checked: true,
    },
  ],
  "Variant Template": {
    TemplateName: "",
    TemplateId: "",
  },
  "Billing Template": {
    TemplateName: "",
    TemplateId: "",
  },
  "Manufacturing Template": {
    TemplateName: "",
    TemplateId: "",
  },
  "Billing Configuration": [
    {
      label: "Header",
      value: "Header",
      checked: true,
    },
    {
      label: "Image",
      value: "Image",
      checked: true,
    },
    {
      label: "Footer",
      value: "Footer",
      checked: true,
    },
    {
      label: "Bill No",
      value: "BillNo",
      checked: true,
    },
    {
      label: "Customer Name",
      value: "Customer",
      checked: true,
    },
    {
      label: "Print Date",
      value: "PrintDate",
      checked: true,
    },
    {
      label: "Date",
      value: "Date",
      checked: true,
    },
    {
      label: "Contact No",
      value: "ContactNo",
      checked: true,
    },
    {
      label: "HSN Code",
      value: "HSNCode",
      checked: true,
    },
    {
      label: "Product Name",
      value: "Product",
      checked: true,
    },
    {
      label: "Quantity",
      value: "Quantity",
      checked: true,
    },
    {
      label: "Rate",
      value: "Rate",
      checked: true,
    },
    {
      label: "Mrp",
      value: "Mrp",
      checked: true,
    },
    {
      label: "Amount",
      value: "Amount",
      checked: true,
    },
    {
      label: "Total Items",
      value: "TotalItems",
      checked: true,
    },
    {
      label: "Total Amount",
      value: "TotalAmount",
      checked: true,
    },
    {
      label: "Total Quantity",
      value: "TotalQuantity",
      checked: true,
    },
    {
      label: "Discount",
      value: "Discount",
      checked: true,
    },
    {
      label: "GST Breakup Details",
      value: "GSTDetails",
      checked: true,
    },
  ],
};

const BarcodeConfig = (props) => {
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);
  const [filters, setFilters] = useState({
    global: { value: null },
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const [barcodeConfigId, setBarcodeConfigId] = useState(null);
  const [barcodeConfigList, setBarcodeConfigList] = useState([]);
  const [isDeleteMaster, setIsDeleteMaster] = useState(false);
  const [isAddMaster, setIsAddMaster] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [isViewMaster, setIsViewMaster] = useState(false);
  const [viewMasterData, setViewMasterData] = useState({});

  const [configName, setConfigName] = useState("");
  const [configNameErr, setConfigNameErr] = useState(false);
  const [configNameErrText, setConfigNameErrText] = useState("");
  const [configValueObj, setConfigValueObj] = useState(configValueList);

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <>
        <div className="p-d-flex p-ai-center">
          <Button
            className="e-add-btn"
            onClick={() => handleOpen(rowData, "EditMaster")}
            tooltip={"Edit"}
            tooltipOptions={{ className: "bluegray-tooltip", position: "top" }}
          >
            <i className="icon-editImage"></i>
          </Button>

          <Button
            className="e-add-btn"
            onClick={() => handleOpen(rowData, "DeleteMaster")}
            tooltip={"Delete"}
            tooltipOptions={{ className: "bluegray-tooltip", position: "top" }}
          >
            <i className="icon-delete"></i>
          </Button>
        </div>
      </>
    );
  };

  useEffect(() => {
    let token = localStorage.getItem("Token");
    let data = localStorage.getItem("Infodata");
    if (token !== null) {
      setUserId(data);
      getBarcodeConfigList(data);
      getTemplateList(data);
    } else {
      props.history.push("/login");
    }
    return () => {};
  }, []);

  const resetScreen = async () => {
    setBarcodeConfigId("");
    setBarcodeConfigList([]);
    setIsAddMaster(false);
    setIsDeleteMaster(false);
    setIsViewMaster(false);
    setConfigName("");
    setConfigNameErr(false);
    setConfigNameErrText("");
    setLoading(false);
    setConfigValueObj(configValueList);
    await getBarcodeConfigList(userId);
  };

  const getBarcodeConfigList = async (UserId) => {
    try {
      setLoading(true);
      let data = {
        UserId,
      };
      await api
        .post(APIConstant.path.GetBarcodeConfiguration, data)
        .then(async (res) => {
          let response = await res;
          if (response.Success === 1) {
            setBarcodeConfigList(response.Data);
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log({ err });
        });
    } catch (err) {
      setLoading(false);
      console.log({ err });
    }
  };
  const getTemplateList = async (UserId) => {
    try {
      setLoading(true);
      let data = {
        UserId,
      };
      await api
        .post(APIConstant.path.GetTemplate, data)
        .then(async (res) => {
          let response = await res;
          if (response.success) {
            setTemplateList(response.data);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log({ err });
        });
    } catch (err) {
      setLoading(false);
      console.log({ err });
    }
  };

  const handleChange = (e, type) => {
    if (type == "configName") {
      if (CommonConfig.isEmpty(e.value)) {
        setConfigName("");
        setConfigNameErr(true);
        setConfigNameErrText("Config type is required");
      } else {
        setConfigName(e.value);
        setConfigNameErr(false);
        setConfigNameErrText("");
      }
    }
  };

  const validation = () => {
    let formIsValid = true;
    if (CommonConfig.isEmpty(configName)) {
      formIsValid = false;
      setConfigNameErr(true);
      setConfigNameErrText("Config is required");
    } else {
      setConfigNameErr(false);
      setConfigNameErrText("");
    }

    if (
      configName === "Manufacturing Barcode" ||
      configName === "Billing Configuration"
    ) {
      let tempList = configValueObj[configName];
      let isHeaderChecked = tempList.find((item) => item.value === "Header")
        ?.checked;
      let isImageChecked = tempList.find((item) => item.value === "Image")
        ?.checked;
      if (isHeaderChecked && isImageChecked) {
        cogoToast.error("Please select either Image or Header");
        formIsValid = false;
      }
    }

    return formIsValid;
  };

  const handleOpen = async (item, type) => {
    if (type === "AddMaster") {
      setIsAddMaster(true);
    } else if (type === "EditMaster") {
      setIsAddMaster(true);
      setBarcodeConfigId(item.BarcodeConfigId);
      setConfigName(item.ConfigName);
      let tempConfigValueObj = { ...configValueObj };
      tempConfigValueObj[item.ConfigName] = item.ConfigValue;
      setConfigValueObj(tempConfigValueObj);
    } else if (type === "DeleteMaster") {
      setBarcodeConfigId(item.BarcodeConfigId);
      setIsDeleteMaster(true);
    } else if (type === "ViewMaster") {
      // setInsuranceCompanyMasterId(item.InsuranceCompanyMasterID);
      setIsViewMaster(true);
      setViewMasterData(item);
    }
  };

  const handleClose = async (type) => {
    if (type === "AddMaster") {
      setIsAddMaster(false);
      resetScreen();
    } else if (type === "EditMaster") {
      setIsAddMaster(false);
      setBarcodeConfigId(false);
      resetScreen();
    } else if (type === "DeleteMaster") {
      setBarcodeConfigList(null);
      setIsDeleteMaster(false);
      resetScreen();
    } else if (type === "ViewMaster") {
      setIsViewMaster(false);
      setViewMasterData({});
    }
  };

  const handleAddMaster = async (e) => {
    e.preventDefault();
    if (validation()) {
      setLoading(true);
      let data = {
        BarcodeConfigId: barcodeConfigId,
        UserId: userId,
        ConfigName: configName,
        ConfigValue: configValueObj[configName],
      };
      try {
        api
          .post(APIConstant.path.AddUpdateBarcodeConfiguration, data)
          .then(async (res) => {
            const response = await res;
            if (response.Success === 1) {
              setLoading(false);
              cogoToast.success(response.Message);
              await resetScreen();
            } else {
              setLoading(false);
              cogoToast.error(response.Message);
            }
          })
          .catch((err) => {
            setLoading(false);
            cogoToast.error(err);
          });
      } catch (err) {
        setLoading(false);
        cogoToast.error(err);
      }
    }
  };

  const handleDeleteMaster = async (Id) => {
    try {
      setLoading(true);
      let data = {
        UserId: userId,
        BarcodeConfigId: barcodeConfigId,
      };
      await api
        .post(APIConstant.path.DeleteBarcodeConfiguration, data)
        .then(async (res) => {
          let response = await res;
          if (response.Success === 1) {
            await resetScreen();
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          cogoToast.error(err);
        });
    } catch (err) {
      setLoading(false);
      cogoToast.error(err);
    }
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilter(value);
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between p-pr-2 p-pl-3">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-filter-slash"></i>
          <h2>Barcode Configuration</h2>
        </div>
        <div className="p-ml-auto p-d-lg-flex p-ai-center">
          <span className="searchbar-area">
            <InputText
              type="search"
              onChange={onGlobalFilterChange}
              placeholder="Global Search"
              size="30"
            />
            <i className="icon-search"></i>
          </span>
        </div>
        <div className="card-actions">
          <Button
            type="button"
            className="e-add-btn"
            onClick={(e) => handleOpen(e, "AddMaster")}
          >
            <i className="icon-add"></i>
          </Button>
        </div>
      </div>
      <hr />
      <div className="custom-large-wb-table e-common-master-table">
        <DataTable
          filters={filters}
          className="main-table table-td"
          value={barcodeConfigList}
          editMode="row"
          dataKey="id"
          responsiveLayout="scroll"
          paginator={true}
          rows={10}
          totalRecords={barcodeConfigList.length}
          rowsPerPageOptions={CommonConfig.dataTableConfig.rowsPerPageOptions}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "5%" }}
          ></Column>
          <Column
            field="ConfigName"
            header="Config"
            style={{ width: "10%" }}
          ></Column>

          <Column
            field="Action"
            header="Action"
            body={actionBodyTemplate}
            headerStyle={{ width: "8%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        </DataTable>
      </div>

      {/* Delete Confirm Modal */}
      <Dialog
        open={isDeleteMaster}
        className="stock-modal"
        onClose={(e) => handleClose("DeleteMaster")}
        fullWidth
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Config</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("DeleteMaster")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent>
          <span>Are you sure want to delete this configuration ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("DeleteMaster")}
          >
            Cancel
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => handleDeleteMaster(barcodeConfigId)}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isAddMaster}
        className="stock-modal"
        onClose={(e) => handleClose("AddMaster")}
        fullWidth
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>{barcodeConfigId ? "Edit Config" : "Add Config"}</div>
          <div className="dialog-close" onClick={(e) => handleClose("Add")}>
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent>
          <>
            <GridItem md={12}>
              <label>Config</label>
              <div className="p-d-flex p-ai-center">
                <Dropdown
                  className="p-w-100 p-mt-1"
                  id="configName"
                  placeholder="Select"
                  value={configName}
                  options={configList}
                  optionLabel="label"
                  onChange={(e) => handleChange(e, "configName")}
                  filter
                />
                <div>
                  {configName ? (
                    <Button
                      tabIndex={-1}
                      icon="pi pi-times"
                      className="p-button-rounded p-button-text p-button-danger p-mt-2"
                      onClick={() => {
                        setConfigName("");
                        setConfigNameErr(false);
                        setConfigNameErrText("");
                      }}
                    />
                  ) : null}
                </div>
                <span className="error-msg" style={{ color: "red" }}>
                  {configNameErr ? configNameErrText : null}{" "}
                </span>
              </div>
            </GridItem>

            {configName === "Variant Template" ||
            configName === "Manufacturing Template" ||
            configName === "Billing Template" ? (
              <>
                <GridItem md={12}>
                  <div className="p-my-3">
                    <Dropdown
                      autoFocus
                      filter
                      options={templateList}
                      value={configValueObj[configName]?.TemplateId}
                      onChange={(e) => {
                        setConfigValueObj((prevState) => ({
                          ...prevState,
                          [configName]: {
                            TemplateId: e.value,
                            TemplateName: templateList.find(
                              (temp) => temp.value === e.value
                            )?.label,
                          },
                        }));
                      }}
                      placeholder="Select Template"
                      className="p-w-100"
                    />
                  </div>
                </GridItem>
              </>
            ) : (
              configValueObj[configName] && (
                <GridItem md={12}>
                  {Object.values(configValueObj[configName]).map(
                    (value, index) => {
                      return (
                        <div className="p-d-flex p-ai-center p-my-3">
                          <Checkbox
                            inputId="apply"
                            name="apply"
                            onChange={(e) => {
                              let tempValueList = { ...configValueObj };
                              tempValueList[configName][index].checked =
                                e.checked;
                              setConfigValueObj(tempValueList);
                            }}
                            checked={value.checked}
                          />
                          <label htmlFor="apply" className="p-ml-2">
                            {value.label}
                          </label>
                        </div>
                      );
                    }
                  )}
                </GridItem>
              )
            )}
          </>
        </DialogContent>
        <DialogActions>
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("AddMaster")}
          >
            Cancel
          </Button>
          <Button className="primary-btn" onClick={(e) => handleAddMaster(e)}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BarcodeConfig;
